module.exports = __webpack_public_path__ + "static/media/PNR.467fa09a.svg";